import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {Routes, RouterModule} from '@angular/router';

import {CallbackComponent} from "./callback.component";
import {CbNaverComponent} from "./cb-naver/cb-naver.component";


const childRoutes: Routes = [
  {
    path: '',
    redirectTo: 'naver',
    pathMatch: 'full',
  },
  {
    path: 'naver',
    component: CbNaverComponent,
  },
];


const routes: Routes = [
  {
    path: 'callback',
    component: CallbackComponent,
    children: childRoutes,
  },
];

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
  ],
})
export class CallbackRoutingModule {
}
